// Helper function to convert Google Drive file ID to direct image URL
const getGoogleDriveThumbnailUrl = (fileId: string, size: number = 800) => {
  return `https://drive.google.com/thumbnail?id=${fileId}&sz=w${size}`
}

// Timeline data structure using real engagement photos
const loveStoryTimeline = [
  {
    id: 1,
    year: "2011",
    title: "High School Chemistry",
    image: getGoogleDriveThumbnailUrl('1vmpsW_7117BQHNHeE4erAXPPR2pW1W-k'),
    description: "Naetzy and Eddie first crossed paths as teenagers at Roma High School. They knew of each other but barely spoke until fate placed them in the same Chemistry class. Naetzy thought Eddie was kinda cute, but let's just say his teenage frontal lobe wasn't quite ready to realize it yet."
  },
  {
    id: 2,
    year: "2018",
    title: "Austin Reunion",
    image: getGoogleDriveThumbnailUrl('1u3q6mzUvnlZDD5TeSbXWXAVZ6ZzlRG0C'),
    description: "Years later, in March 2018, Naetzy was visiting Austin for a hot air balloon festival, while Eddie was out soaking in the South by Southwest (SXSW) festivities. That night, they both ended up on Austin's iconic 6th Street and out of all the bars bumped into each other at Shakespeare's. Eddie wasted no time buying Naetzy and her friends a round of drinks, and with a little liquid courage, asked for her Snapchat. They kept in touch, went on a few dates, and while Naetzy thought it wasn't going anywhere, Eddie was convinced it was heading everywhere. The timing wasn't quite right, and life pulled them in different directions."
  },
  {
    id: 3,
    year: "2021",
    title: "Second Chances",
    image: getGoogleDriveThumbnailUrl('1mhrP9D21-Dhhsku9P-ycDFuhETJPQ4ZY'),
    description: "Fast forward to 2021, social media brought Naetzy and Eddie back together. This time, they decided to give things a real shot and dated for several months. When a family wedding came up, Naetzy invited Eddie as her date. In true Eddie fashion, he confidently introduced himself to her entire family as her boyfriend even though they hadn't made things official yet. It was a bold move, but one that quickly turned into reality when Eddie decided to seal the deal and officially ask Naetzy to be his girlfriend. From that moment on, they were inseparable."
  },
  {
    id: 4,
    year: "2025",
    title: "Saying Yes to Forever",
    image: getGoogleDriveThumbnailUrl('1pidcb7P80yn_qWQ1O3lywfR_mIaRh5TR'),
    description: "After years of adventures and laughter in Austin and around the world, Eddie knew it was time to take the next step. In early 2025, they set off on a weeklong trip to Iceland, with one goal: to see the Northern Lights. But Eddie had an even bigger plan. During a private tour of the breathtaking Katla Ice Cave near Vik complete with a 'secret' photographer, Eddie dropped to one knee beneath a glittering ice arch and asked Naetzy to be his forever partner. She said yes, and the rest, as they say, is just the beginning."
  },
  {
    id: 5,
    year: "April 4, 2026",
    title: "Wedding!",
    image: null,
    description: null
  }
]

export function LoveStoryTimeline() {
  return (
    <section className="section-padding bg-white">
      <div className="container-max">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-serif text-primary-900 mb-6">
            Our Love Story
          </h2>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="relative">
            {/* Central Timeline Line */}
            <div className="absolute left-1/2 transform -translate-x-1/2 w-0.5 bg-gradient-to-b from-primary-200 via-primary-300 to-primary-400 h-full hidden md:block"></div>
            
            {loveStoryTimeline.map((item, index) => (
              <div key={item.id} className="relative mb-12 md:mb-20">
                
                {/* Mobile Layout */}
                <div className="md:hidden">
                  {/* Mobile Timeline Dot and Content */}
                  <div className="flex items-start">
                    <div className="flex flex-col items-center mr-4 mt-2">
                      <div className="w-4 h-4 bg-primary-500 rounded-full shadow-lg z-10 relative"></div>
                      {index < loveStoryTimeline.length - 1 && (
                        <div className="w-0.5 h-96 bg-primary-200 mt-2"></div>
                      )}
                    </div>
                    
                    <div className="flex-1 pb-8">
                      {/* Mobile Year & Title */}
                      <div className="mb-4">
                        <span className="inline-block px-3 py-1 bg-primary-100 text-primary-800 font-semibold rounded-full text-sm mb-2">
                          {item.year}
                        </span>
                        <h3 className="text-xl font-serif text-primary-900 mb-3">
                          {item.title}
                        </h3>
                      </div>
                      
                      {/* Mobile Photo */}
                      {item.image && (
                        <div className="mb-4">
                          <div className="bg-white rounded-xl shadow-md overflow-hidden">
                            <img
                              src={item.image}
                              alt={item.title}
                              className="w-full h-auto object-cover"
                              loading="lazy"
                            />
                          </div>
                        </div>
                      )}
                      
                      {/* Mobile Description */}
                      {item.description && (
                        <p className="text-neutral-600 leading-relaxed text-sm">
                          {item.description}
                        </p>
                      )}
                    </div>
                  </div>
                </div>

                {/* Desktop Layout */}
                <div className="hidden md:flex items-center">
                  {/* Photo Side - Only render if image exists */}
                  {item.image && (
                    <div className={`w-5/12 ${index % 2 === 0 ? 'order-1 pr-8' : 'order-3 pl-8'}`}>
                      <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                        <img
                          src={item.image}
                          alt={item.title}
                          className="w-full h-auto object-cover"
                          loading="lazy"
                        />
                      </div>
                    </div>
                  )}

                  {/* Center Timeline - Year & Title */}
                  <div className={`${item.image ? 'order-2 w-2/12' : 'w-full'} flex justify-center relative`}>
                    <div className="text-center bg-white rounded-2xl shadow-lg px-6 py-4 border-4 border-primary-100 z-20">
                      <span className="block text-primary-600 font-bold text-lg mb-1">
                        {item.year}
                      </span>
                      <h3 className="text-primary-900 font-serif text-lg leading-tight">
                        {item.title}
                      </h3>
                    </div>
                    {/* Timeline dot behind the card */}
                    <div className="absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2 w-6 h-6 bg-primary-500 rounded-full z-10"></div>
                  </div>
                  
                  {/* Text Side - Only render if description exists */}
                  {item.description && (
                    <div className={`w-5/12 ${index % 2 === 0 ? 'order-3 pl-8' : 'order-1 pr-8'}`}>
                      <div className="p-6">
                        <p className="text-neutral-600 leading-relaxed">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
